
























import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
    });

    /******************************
     * methods
     ******************************/

    const download = async (): Promise<void> => {
      window.location.href = `/api/teacher_excel_upload/download`;
    }

    /**
     * アップロード処理
     */
    const upload = async (file: File): Promise<void> => {

      state.errors = [];

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      const formData = new FormData();
      formData.append(`upload[file]`, file);

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher_excel_upload/upload`, formData).then(response => {
        alert(`アップロードが完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      download,
      upload,
    };
  },
})
